import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Layout from './components/layout/layout'
import Home from './components/pages/home'
import AuthorityHome from './components/pages/authority-home'
import Media from './components/pages/media'
import ScrollToTop from './components/common/scroll-to-top'

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="media" element={<Media />} />
        </Route>
        <Route path="/trust" element={<div className="theme-authority"><Layout /></div>}>
          <Route index element={<AuthorityHome />} />
        </Route>
      </Routes>
    </>
  )
}
